export default {
    path: '/yindao',
    name: 'yindao',
    component: () => import('@/layouts/YinDaoYe'),
    children: [

    ],
  }